import './style.scss';
export default function Loading() {
    return <h2 className="loading-middle">🌀 Loading...</h2>;
}
